import { render, staticRenderFns } from "./breadcrumb-component.vue?vue&type=template&id=11d4e287&scoped=true&"
import script from "./breadcrumb-component.vue?vue&type=script&lang=ts&"
export * from "./breadcrumb-component.vue?vue&type=script&lang=ts&"
import style0 from "./breadcrumb-component.vue?vue&type=style&index=0&id=11d4e287&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d4e287",
  null
  
)

export default component.exports